import { Card, Col, Form, Input, Pagination, Row, Space } from "antd";
import { useState } from "react";
import FeatureToolbarComponent from "../sgvmap/widgets/feature/FeatureToolbarComponent";

const VicaBalsas = ({ results, mapView, table, mapLayer, sublayer, currentTabsResult, setCurrenTabsResult }) => {
    const [result, setResult] = useState(results[0]);
    const [current, setCurrent] = useState(1);

    const onChangePagination = (page) => {
        setCurrent(page);
        setResult(results[page - 1]);
        let copy = Object.assign({}, currentTabsResult);
        copy[mapLayer.name + ": " + sublayer.title] = results[page - 1];
        setCurrenTabsResult(copy);
    };

    return (
        <>
            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}
            <Row justify="end" style={{ paddingBottom: "10px", paddingTop: "5px" }}>
                <FeatureToolbarComponent mapView={mapView} table={table} mapLayer={mapLayer} sublayer={sublayer} feature={result.feature}></FeatureToolbarComponent>
            </Row>
            <div>
                <Content result={result}></Content>
            </div>

            {results.length > 1 && <Row>
                <Col span={24}>
                    <Pagination style={{ float: "right" }} simple pageSize={1} current={current} onChange={onChangePagination} total={results.length} />
                </Col>
            </Row>}
        </>
    );
};

export default VicaBalsas;

const FormSection = ({ title, children }) => (
    <div style={{ marginBottom: 16 }}>
        <div style={{ fontWeight: 500, marginBottom: 8 }}>{title}</div>
        <div style={{ border: "1px solid #d9d9d9", borderRadius: 6, padding: "8px 16px 4px" }}>
            {children}
        </div>
    </div>
);

const Content = ({ result }) => {
    const attrs = result.feature.attributes;

    const formatNumber = (num) => {
        if (num == null || num === undefined || num === "") {
            return "-";
        }
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const formatValue = (value) => {
        if (value == null || value === undefined || value === "") {
            return "-";
        }
        return value;
    };

    const formatHuso = (value) => {
        if (value == null || value === undefined || value === "") {
            return "HUSO -";
        }
        return `HUSO ${value}`;
    };

    return (
        <Card>
            <Form layout="horizontal">
                <Form.Item label="Código infraestructura">
                    <Input value={formatValue(attrs.COD_INFRA)} />
                </Form.Item>
                <Form.Item label="N.º inscripción">
                    <Input value={formatValue(attrs.NUM_INSCRIPCION)} />
                </Form.Item>
                <Form.Item label="Nombre">
                    <Input value={formatValue(attrs.NOMBRE_BALSA)} />
                </Form.Item>
                <Form.Item label="Clasificación">
                    <Input value={formatValue(attrs.CLASIFICACION)} />
                </Form.Item>

                <FormSection title="Localización">
                    <Form.Item label="Municipio">
                        <Input value={formatValue(attrs.MUNICIPIO)} />
                    </Form.Item>
                    <Form.Item label="Provincia">
                        <Input value={formatValue(attrs.PROVINCIA)} />
                    </Form.Item>
                </FormSection>

                <FormSection title="Coordenadas ETRS89">
                    <Space.Compact block>
                        <Input addonBefore="X" value={formatNumber(attrs.UTMX_ETRS89)} />
                        <Input addonBefore="Y" value={formatNumber(attrs.UTMY_ETRS89)} />
                        <Input value={formatHuso(attrs.HUSO)} style={{ maxWidth: 110 }} />
                    </Space.Compact>
                </FormSection>
            </Form>
        </Card>
    );
};
